module.exports = __webpack_public_path__ + "static/blueprint-68311b47808323f479e62da23ff901ee.png";